import { useEffect } from "react";
import { useFormikContext } from "formik";
import type { CompanyRegistrationValues } from "../model/registrationTypes";
import { syncConditionalRegistrationFields } from "../sync/syncConditionalRegistrationFields";

export const useSyncConditionalRegistrationFields = (): void => {
  const { values, setFieldValue } =
    useFormikContext<CompanyRegistrationValues>();

  useEffect(() => {
    syncConditionalRegistrationFields(values, setFieldValue);
  }, [values, setFieldValue]);
};
